import { Link } from "react-router-dom";
import Footer from "../components/Footer";

export default function Pricing() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Navbar */}
      <header className="bg-white shadow-md py-4 px-6 flex justify-between items-center">
        <Link to="/" className="text-2xl font-bold text-indigo-600">
          Bill-Lex
        </Link>
        <div className="space-x-4">
          <Link to="/login" className="text-gray-600 hover:text-indigo-600">
            Login
          </Link>
          <Link
            to="/register"
            className="text-white bg-indigo-600 px-4 py-2 rounded hover:bg-indigo-700"
          >
            Get Started
          </Link>
        </div>
      </header>

      {/* Pricing Content */}
      <main className="flex-1 px-4 py-20 text-center bg-gray-50">
        <h2 className="text-4xl font-bold mb-4">
          Transparent & Affordable Pricing
        </h2>
        <p className="text-gray-600 mb-12 text-lg max-w-2xl mx-auto">
          Choose a plan that suits your business needs. Start free and upgrade
          anytime as you grow.
        </p>

        <div className="flex justify-center gap-10 flex-wrap px-4 max-w-6xl mx-auto">
          {/* Starter Plan */}
          <div className="bg-white shadow-lg rounded-xl p-8 w-80 border hover:shadow-xl transition-shadow duration-300">
            <div className="mb-6">
              <h3 className="text-2xl font-bold mb-2">Starter</h3>
              <p className="text-5xl font-semibold mb-2 text-indigo-600">₹0</p>
              <p className="text-gray-500 text-sm">
                Perfect for small businesses
              </p>
            </div>
            <ul className="text-gray-600 mb-8 space-y-3 text-left">
              <li className="flex items-center">
                <span className="text-green-500 mr-3 text-lg">✔</span>
                Up to 5 inventory items
              </li>
              <li className="flex items-center">
                <span className="text-green-500 mr-3 text-lg">✔</span>
                Max 10 bills per day
              </li>
              <li className="flex items-center">
                <span className="text-green-500 mr-3 text-lg">✔</span>
                Basic billing features
              </li>
              <li className="flex items-center">
                <span className="text-green-500 mr-3 text-lg">✔</span>
                Daily sales overview
              </li>
              <li className="flex items-center">
                <span className="text-red-500 mr-3 text-lg">✖</span>
                <span className="text-gray-400">No payment options</span>
              </li>
              <li className="flex items-center">
                <span className="text-red-500 mr-3 text-lg">✖</span>
                <span className="text-gray-400">Limited analytics</span>
              </li>
            </ul>
            <Link
              to="/register"
              className="w-full bg-indigo-100 text-indigo-700 px-6 py-3 rounded-lg hover:bg-indigo-200 transition-colors duration-300 font-semibold inline-block"
            >
              Get Started Free
            </Link>
          </div>

          {/* Pro Plan */}
          <div className="bg-indigo-600 text-white shadow-xl rounded-xl p-8 w-80 border-2 border-indigo-700 transform hover:scale-105 transition-all duration-300 relative">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <span className="bg-green-500 text-white px-4 py-1 rounded-full text-sm font-semibold">
                Most Popular
              </span>
            </div>
            <div className="mb-6">
              <h3 className="text-2xl font-bold mb-2">Pro</h3>
              <p className="text-5xl font-semibold mb-2">₹359/mo</p>
              <p className="text-indigo-200 text-sm">
                Best for growing businesses
              </p>
            </div>
            <ul className="mb-8 space-y-3 text-left">
              <li className="flex items-center">
                <span className="text-green-400 mr-3 text-lg">✔</span>
                Unlimited inventory items
              </li>
              <li className="flex items-center">
                <span className="text-green-400 mr-3 text-lg">✔</span>
                Unlimited bills per day
              </li>
              <li className="flex items-center">
                <span className="text-green-400 mr-3 text-lg">✔</span>
                Payment options enabled
              </li>
              <li className="flex items-center">
                <span className="text-green-400 mr-3 text-lg">✔</span>
                Full analytics & reports
              </li>
              <li className="flex items-center">
                <span className="text-green-400 mr-3 text-lg">✔</span>
                Priority customer support
              </li>
              <li className="flex items-center">
                <span className="text-green-400 mr-3 text-lg">✔</span>
                Multi-user access
              </li>
              <li className="flex items-center">
                <span className="text-green-400 mr-3 text-lg">✔</span>
                Offline mode support
              </li>
            </ul>
            <Link
              to="/register"
              className="w-full bg-white text-indigo-700 px-6 py-3 rounded-lg hover:bg-indigo-100 transition-colors duration-300 font-semibold inline-block"
            >
              Start Free Trial
            </Link>
          </div>

          {/* Enterprise Plan */}
          <div className="bg-white shadow-lg rounded-xl p-8 w-80 border hover:shadow-xl transition-shadow duration-300">
            <div className="mb-6">
              <h3 className="text-2xl font-bold mb-2">Enterprise</h3>
              <p className="text-5xl font-semibold mb-2 text-indigo-600">
                Custom
              </p>
              <p className="text-gray-500 text-sm">For large organizations</p>
            </div>
            <ul className="text-gray-600 mb-8 space-y-3 text-left">
              <li className="flex items-center">
                <span className="text-green-500 mr-3 text-lg">✔</span>
                All Pro features included
              </li>
              <li className="flex items-center">
                <span className="text-green-500 mr-3 text-lg">✔</span>
                Custom integrations
              </li>
              <li className="flex items-center">
                <span className="text-green-500 mr-3 text-lg">✔</span>
                Dedicated account manager
              </li>
              <li className="flex items-center">
                <span className="text-green-500 mr-3 text-lg">✔</span>
                Advanced security features
              </li>
              <li className="flex items-center">
                <span className="text-green-500 mr-3 text-lg">✔</span>
                Custom reporting
              </li>
              <li className="flex items-center">
                <span className="text-green-500 mr-3 text-lg">✔</span>
                24/7 phone support
              </li>
            </ul>
            <Link
              to="/contact"
              className="w-full bg-indigo-600 text-white px-6 py-3 rounded-lg hover:bg-indigo-700 transition-colors duration-300 font-semibold inline-block"
            >
              Contact Sales
            </Link>
          </div>
        </div>

        {/* Additional Information */}
        <div className="mt-16 max-w-4xl mx-auto px-4">
          <div className="bg-white rounded-xl p-8 shadow-lg">
            <h3 className="text-2xl font-bold mb-6 text-center">
              Frequently Asked Questions
            </h3>
            <div className="grid md:grid-cols-2 gap-8 text-left">
              <div>
                <h4 className="font-semibold mb-2 text-indigo-600">
                  Can I upgrade or downgrade my plan?
                </h4>
                <p className="text-gray-600 text-sm">
                  Yes, you can change your plan at any time. Changes take effect
                  immediately.
                </p>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-indigo-600">
                  Is there a free trial?
                </h4>
                <p className="text-gray-600 text-sm">
                  Yes, all paid plans come with a 7-day free trial. No credit
                  card required.
                </p>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-indigo-600">
                  What payment methods do you accept?
                </h4>
                <p className="text-gray-600 text-sm">
                  We accept all major credit cards, UPI, and net banking through
                  our secure payment partner.
                </p>
              </div>
              <div>
                <h4 className="font-semibold mb-2 text-indigo-600">
                  Can I cancel anytime?
                </h4>
                <p className="text-gray-600 text-sm">
                  Yes, you can cancel your subscription at any time. No
                  long-term contracts required.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}
